module.exports = __webpack_public_path__ + "media/images/home_page_my_apps-f3226b9091905aa39746cd69cc00191b.png";